  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
//import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import Menu                                                from '@material-ui/core/Menu';
//import ListItemText                                        from '@material-ui/core/ListItemText';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import TagManager                                          from 'react-gtm-module'
  import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_TransactionFlow }                              from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
  //------
  // Style
  //------
  import TransferOnline4cStyle                               from "./TransferOnline4cStyle.jsx";
  //-------
  // images
  //-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import imgSuccess                                          from "assets/img/wu/success_payment_1.png";
//import share_MTCN                                          from "assets/img/wu/share_MTCN.svg";
  import copy_MTCN                                           from "assets/img/wu/copy_MTCN.svg";
//import WU_CopyCard                                         from "@material-ui/icons/CopyAll";
  //----------
  // variables
  //----------
  const filename = "TransferOnline4c ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

class TransferOnline4c extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,

      mtcn                                                 : "",
      mtcn_exists                                          : false,

      open                                                 : false,
      anchorEl                                             : null,

      initialLoad                                          : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    this.makeScreenTranslations                                       = this.makeScreenTranslations.bind(this);

    this.share_MTCN_act                                               = this.share_MTCN_act.bind(this);

    this.btn_gotoTransferHome_act                                     = this.btn_gotoTransferHome_act.bind(this);

    //[SNACKBAR]for
    this.Snackbar_textField_handleOpen                               = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                              = this.Snackbar_textField_handleClose.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    //---------------------------
    //Peiraius Private Mode Issue
    //---------------------------
    this.load_cookies_to_localStorage();
    wu_Utilities.printSomeValuesFromLocalStorage();

    this.startSpinners();
    setTimeout(function() { //Start the timer
    //-------------------
    //wu_validatecustomer
    //-------------------
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

      //------------------
      //Repeat Transaction
      //------------------
      try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}

      //----------------
      //finalizeoutbound
      //----------------
      let parserObject_finalizeoutbound_req = {};

      //wantMktInfo should be in a cookie?
      //let wantMktInfo = localStorage.getItem("wantMktInfo");
      //parserObject_finalizeoutbound_req["wantMktInfo"] = (wantMktInfo===null || (typeof wantMktInfo ==="undefined")) ? "" : wantMktInfo;

      let centralID = "";
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          try {
            let parserObject_sendoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b"));
            centralID = parserObject_sendoutbound_d2b["centralID"]; if(centralID===null){centralID = "";}
          } catch(err){;}
      }
      else{
          try {
            let parserObject_sendoutbound     = JSON.parse(localStorage.getItem("parserObject_sendoutbound"));
            centralID = parserObject_sendoutbound["centralID"];     if(centralID===null){centralID = "";}
          } catch(err){;}
      }
      parserObject_finalizeoutbound_req["isSofort"]  = "0"
      parserObject_finalizeoutbound_req["centralID"] = centralID;

      if(Cookies.get('wuwb4c_cardPaymentStatus')==="success"){
        parserObject_finalizeoutbound_req["finalizeoutbound_type"] = "finalizeoutbound_type_CreditCard_success";
        //basic attributes
        parserObject_finalizeoutbound_req["transactionId"]         = Cookies.get('wuwb4c_TransactionId');
        parserObject_finalizeoutbound_req["supportReferenceID"]    = Cookies.get('wuwb4c_SupportReferenceID');
        parserObject_finalizeoutbound_req["approvalCode"]          = Cookies.get('wuwb4c_ApprovalCode');
        parserObject_finalizeoutbound_req["packageNo"]             = Cookies.get('wuwb4c_PackageNo');
        parserObject_finalizeoutbound_req["responseCode"]          = Cookies.get('wuwb4c_ResponseCode');
        parserObject_finalizeoutbound_req["retrievalRef"]          = Cookies.get('wuwb4c_RetrievalRef');
        parserObject_finalizeoutbound_req["resultCode"]            = Cookies.get('wuwb4c_ResultCode');
        //extra attributes
        parserObject_finalizeoutbound_req["resultDescription"]     = Cookies.get('wuwb4c_ResultDescription');
        parserObject_finalizeoutbound_req["statusFlag"]            = Cookies.get('wuwb4c_StatusFlag');
        parserObject_finalizeoutbound_req["responseDescription"]   = Cookies.get('wuwb4c_ResponseDescription');
        parserObject_finalizeoutbound_req["merchantRef"]           = Cookies.get('wuwb4c_MerchantRef');
        parserObject_finalizeoutbound_req["transDatetime"]         = Cookies.get('wuwb4c_TransDatetime');
      }
      else{
        parserObject_finalizeoutbound_req["finalizeoutbound_type"] = "finalizeoutbound_type_CreditCard_failure";
        //basic attributes
        parserObject_finalizeoutbound_req["transactionId"]         = Cookies.get('wuwb4c_TransactionId');
        parserObject_finalizeoutbound_req["supportReferenceID"]    = Cookies.get('wuwb4c_SupportReferenceID');
        parserObject_finalizeoutbound_req["approvalCode"]          = Cookies.get('wuwb4c_ApprovalCode');
        parserObject_finalizeoutbound_req["packageNo"]             = Cookies.get('wuwb4c_PackageNo');
        parserObject_finalizeoutbound_req["responseCode"]          = Cookies.get('wuwb4c_ResponseCode');
        parserObject_finalizeoutbound_req["retrievalRef"]          = Cookies.get('wuwb4c_RetrievalRef');
        parserObject_finalizeoutbound_req["resultCode"]            = Cookies.get('wuwb4c_ResultCode');
        //extra attributes
        parserObject_finalizeoutbound_req["resultDescription"]     = Cookies.get('wuwb4c_ResultDescription');
        parserObject_finalizeoutbound_req["statusFlag"]            = Cookies.get('wuwb4c_StatusFlag');
        parserObject_finalizeoutbound_req["responseDescription"]   = Cookies.get('wuwb4c_ResponseDescription');
        parserObject_finalizeoutbound_req["merchantRef"]           = Cookies.get('wuwb4c_MerchantRef');
        parserObject_finalizeoutbound_req["transDatetime"]         = Cookies.get('wuwb4c_TransDatetime');
      }
      //-------------------
      //wu_finalizeoutbound
      //-------------------
      wu_TransactionFlow
      .wu_finalizeoutbound(parserObject_finalizeoutbound_req)
      .then(res => {
      //localStorage.setItem("parserObject_finalizeoutbound_req",JSON.stringify(parserObject_finalizeoutbound_req));
        localStorage.setItem("parserObject_finalizeoutbound",    JSON.stringify(res));
        //-------------------
        //wu_validatecustomer
        //-------------------
        wu_ProfileService
        .wu_validatecustomer({})
        .then(res => {
          this.clear_cookies_not_needed();
          this.stopSpinners();
          localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));
          this.makeScreenTranslations();
        })
        .catch(err => {
          this.clear_cookies_not_needed();
          this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){
            if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-01)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
            this.dialog_handleOpen(err.returnText);
          }
        });
      })
      .catch(err => {
        this.clear_cookies_not_needed();
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){
          if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-02)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
          this.dialog_handleOpen(err.returnText);
        }
      });
    })
    .catch(err => {
      this.clear_cookies_not_needed();
      this.stopSpinners();
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){
        if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-03)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
        this.dialog_handleOpen(err.returnText);
      }
    });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            <div style={{ marginTop: 20 }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.TransferOnline4c_view_success_lbl_lbl0}>{this.NSInforString("TransferOnline4c_view_success_lbl_lbl0")}</div>
                </GridItem>
              </GridContainer>
            </div>

            {this.state.initialLoad === true ? ("") : (
            <div>
              <div className={classes.imgSuccess}><img width="80px" height="80px" src={imgSuccess} alt="" /></div>

              {(this.state.mtcn_exists === true && localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Cash) ? (
                <div style={{ marginTop: 20 }}>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_lbl}>{this.NSInforString("TransferOnline4c_view_success_lbl_lbl1_mtcn_cash")}</div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_mtcn}>
                            &nbsp;&nbsp;&nbsp;
                            {this.state.mtcn}
                            <Button onClick={this.share_MTCN_act}><div className={classes.share_MTCN}><img src={copy_MTCN} alt=""/></div></Button>
                            <div style={{ willChange: "transform" }}>
                              {/* <Snackbar
                                bodyStyle={{ backgroundColor: 'white', color: 'black' }}
                                open={this.state.Snackbar_textField_open}
                                autoHideDuration={1000}
                                onClose={this.Snackbar_textField_handleClose}>
                                <Alert onClose={this.Snackbar_textField_handleClose} severity="info">{this.state.Snackbar_textField_msg}</Alert>
                              </Snackbar> */}
                              <Snackbar
                                open={this.state.Snackbar_textField_open}
                                autoHideDuration={api.snackBarDurationMS}
                                onClose={this.Snackbar_textField_handleClose}
                                ContentProps={{ classes: { root: classes.copy2clipboard } }}
                                message={<span>{this.state.Snackbar_textField_msg}</span>}
                              />
                            </div>
                          </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_lbl}>{this.NSInforString("TransferOnline4c_view_success_lbl_lbl2_mtcn_cash")}</div>
                      </GridItem>
                    </GridContainer>
                </div>
              ) : ( "" ) }

              {(this.state.mtcn_exists === true && localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank) ? (
                <div style={{ marginTop: 20 }}>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_lbl}>{this.NSInforString("TransferOnline4c_view_success_lbl_lbl1_mtcn_d2b")}</div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_mtcn}>
                            &nbsp;&nbsp;&nbsp;
                            {this.state.mtcn}
                            <Button onClick={this.share_MTCN_act}><div className={classes.share_MTCN}><img src={copy_MTCN} alt=""/></div></Button>
                            <div style={{ willChange: "transform" }}>
                              {/* <Snackbar
                                bodyStyle={{ backgroundColor: 'white', color: 'black' }}
                                open={this.state.Snackbar_textField_open}
                                autoHideDuration={1000}
                                onClose={this.Snackbar_textField_handleClose}>
                                <Alert onClose={this.Snackbar_textField_handleClose} severity="info">{this.state.Snackbar_textField_msg}</Alert>
                              </Snackbar> */}
                              <Snackbar
                                open={this.state.Snackbar_textField_open}
                                autoHideDuration={api.snackBarDurationMS}
                                onClose={this.Snackbar_textField_handleClose}
                                ContentProps={{ classes: { root: classes.copy2clipboard } }}
                                message={<span>{this.state.Snackbar_textField_msg}</span>}
                              />
                            </div>
                          </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_lbl}>{this.NSInforString("TransferOnline4c_view_success_lbl_lbl2_mtcn_d2b")}</div>
                      </GridItem>
                    </GridContainer>
                </div>
              ) : ( "" ) }

              {(this.state.mtcn_exists === false && localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Cash) ? (
                <div style={{ marginTop: 20 }}>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_lbl}>{this.NSInforString("TransferOnline4c_view_success_lbl_lbl1_nomtcn_cash")}</div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_mtcn}>{this.state.mtcn}</div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_lbl}>{this.NSInforString("TransferOnline4c_view_success_lbl_lbl2_nomtcn_cash")}</div>
                      </GridItem>
                    </GridContainer>
                </div>
              ) : ( "" ) }

              {(this.state.mtcn_exists === false && localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank) ? (
                <div style={{ marginTop: 20 }}>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_lbl}>{this.NSInforString("TransferOnline4c_view_success_lbl_lbl1_nomtcn_d2b")}</div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_mtcn}>{this.state.mtcn}</div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                          <div className={classes.TransferOnline4c_view_success_lbl}>{this.NSInforString("TransferOnline4c_view_success_lbl_lbl2_nomtcn_d2b")}</div>
                      </GridItem>
                    </GridContainer>
                </div>
              ) : ( "" ) }

              {/* ------------------------- */}
              {/* ----------[BUTTONS]------ */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_gotoTransferHome_act}
                        type="submit">
                        {this.NSInforString("TransferOnline4c_view_success_btn_gotoTransferHome")}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              </div>

            </div>
            )}
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Make HTTP & Setup UI------------------------------
  //----------------------------------------------------------------------------------------------------
  makeScreenTranslations(){
      let methName = filename+"makeScreenTranslations ";
      //if(api.print_logs){console.log(methName);}

      let parserObject_finalizeoutbound = {};
      try { parserObject_finalizeoutbound = JSON.parse(localStorage.getItem("parserObject_finalizeoutbound")); }catch(err){;}

      let mtcn = "";
      try {mtcn = parserObject_finalizeoutbound["mtcn"]; }catch(err){;}
      if(mtcn===null || (typeof mtcn ==="undefined")){mtcn = "";}

      //nailed for testing:START
      //mtcn = "1234567890";
      //localStorage.setItem("TransferOnline1_TransferMethod",api.TransferOnline1_TransferMethod_Cash);
      //console.log(methName+"mtcn="+mtcn);
      //nailed for testing:end

      if(mtcn!==""){
          this.setState({
            "mtcn"        : mtcn,
            "mtcn_exists" : true,
          });
      }
      else{
        this.setState({
          "mtcn"        : mtcn,
          "mtcn_exists" : false,
        });
      }
      //-------------------
      //Tag Event Recording
      //-------------------
      let shouldUseTagManager = api.shouldUseTagManager;
      if(shouldUseTagManager===true){
        let centralID       = this.get_centralID();       //
        let snd_curr        = 'EUR';                      //
      //let rcv_curr        = this.get_rcv_curr();        //
        let dest_ctry_wu_id = this.get_dest_ctry_wu_id(); //GR,AL
        let gross           = this.get_gross();           //
        let paymentType     = 'paybycard';                //'banktransfer', 'paybycard'
        let transferMethod  = (localStorage.getItem("TransferOnline1_TransferMethod")===api.TransferOnline1_TransferMethod_Cash) ? "cash" : "d2b";
        let brand           = '';//(localStorage.getItem("TransferOnline1_TransferMethod")===api.TransferOnline1_TransferMethod_Cash) ? "Store Pick Up" : "APN-D2B";

        let tagManagerData = {
          'event' : 'purchase',
          'ecommerce': {
            'currencyCode': snd_curr,           //'EUR', // αναλογα με το νομισμα  εκτός αν μετατρέπονται ολα σε eur
            'purchase' : {
              'actionField': {
                'id'          : centralID,      // Transaction ID. Required for purchases and refunds.  ο αριθμός συναλλαγής όχι ο κωδικός πληρωμής του πελάτη
                'affiliation' : paymentType,    // προτείνουμε να παίρνει τιμές paybycard/banktransfer ανάλογα με το τι εχει επιλέξει ο κάθε πελατης
                'revenue'     : gross,          // Total transaction value (incl. tax and shipping). Ανάλογα με το νόμισμα εκτός αν τα μετατρέπετε ολα σε eur οπότε αντίστοιχα
                'tax'         : '',             // σε περίπτωση που εχουν νόημα τα πεδία αυτα
                'shipping'    : '',             // σε περίπτωση που έχουν νόημα τα πεδια αυτά, Πχ Προμήθεια συναλλαγής
                'coupon'      : '',             // σε περίπτωση που εχουν νόημα τα πεδια αυτα
              },
              'products' : [{                   // List of productFieldObjects.
                'name'     : paymentType,       // Name or ID is required., προτείνουμε να παίρνει τιμές paybycard/banktransfer ανάλογα με το τι εχει επιλέξει ο κάθε πελατης
                'id'       : 'card',            // προτείνουμε να παίρνει τιμές τον κωδικό πληρωμής όταν μιλάμε για μεταφορα μεσω τραπεζας ή ένα σταθερό id όταν μιλάμε για πληρωμή μέσω κάρτας
                'price'    : gross,             //
                'brand'    : brand,             //(25/03/2021)σε περίπτωση που έχει νόημα το πεδιο αυτό μπορούμε να το χρησιμοποιήσουμε για έξτρα πληροφορίες
                'category' : dest_ctry_wu_id,   //χωρα που παει το έμβασμα,
                'variant'  : transferMethod,    //[cash/d2b]
                'quantity' : 1,
              }],
            }
          }
        };
        //TagManager.dataLayer(tagManagerData);
        try { window.dataLayer.push(tagManagerData);                }catch(err1){console.log(methName+"err1="+err1);}
        try { console.log(methName+JSON.stringify(tagManagerData)); }catch(err2){console.log(methName+"err2="+err2);}
      }
      //----------------------
      //Criteo Event Recording
      //----------------------
      let shouldUseCriteo = api.shouldUseCriteo;
      if(shouldUseCriteo===true && api.webappENV==="PROD"){
        try {
          let email           = localStorage.getItem("HTTP_user");
          let centralID       = this.get_centralID();       //
        //let gross           = this.get_gross();           //
          window.criteo_q = window.criteo_q || [];
          var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
          window.criteo_q.push(
           { event: "setAccount", account: api.criteo_account }, // You should never update this line
           { event: "setEmail", email: email },                  // Can be an empty string
           { event: "setSiteType", type: deviceType},
           { event: "trackTransaction", id: centralID, item: [{id:"1", price:1, quantity:1}] }
          );
        }catch(err0){console.log(methName+"err0="+err0);}
      }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  get_centralID(){
    let centralID = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b"));
        centralID = parserObject_sendoutbound_d2b["centralID"]; if(centralID===null){centralID = "";}
    }
    else{
        let parserObject_sendoutbound     = JSON.parse(localStorage.getItem("parserObject_sendoutbound"));
        centralID = parserObject_sendoutbound["centralID"];     if(centralID===null){centralID = "";}
    }
    if(centralID === null || (typeof centralID ==="undefined")){ return ""; }
    return centralID;
  }
  get_rcv_curr(){
    let rcv_curr   = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b_req = {};
        try { parserObject_sendoutbound_d2b_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b_req")); }catch(err){;}
        try {rcv_curr  = parserObject_sendoutbound_d2b_req["rcv_curr"];  }catch(err){;} if(rcv_curr === null || (typeof rcv_curr==="undefined")){rcv_curr = "";}
    }
    else{
        let parserObject_sendoutbound_req = {};
        try { parserObject_sendoutbound_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_req")); }catch(err){;}
        try {rcv_curr  = parserObject_sendoutbound_req["rcv_curr"];  }catch(err){;} if(rcv_curr === null || (typeof rcv_curr==="undefined")){rcv_curr = "";}
    }
    if(rcv_curr === null || (typeof rcv_curr ==="undefined")){ return ""; }
    return rcv_curr;
  }
  get_gross(){
    let methName = filename+"get_gross ";
    //if(api.print_logs){console.log(methName);}

    let gross = 0.0;
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_validateoutbound_d2b = {};
        try { parserObject_validateoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_validateoutbound_d2b")); }catch(err1){ console.log(methName+'err1='+err1); }
        try {gross = parserObject_validateoutbound_d2b["gross"]; }catch(err2){ console.log(methName+'err2='+err2); }
    }
    else{
        let parserObject_validateoutbound = {};
        try { parserObject_validateoutbound = JSON.parse(localStorage.getItem("parserObject_validateoutbound")); }catch(err3){ console.log(methName+'err3='+err3); }
        try {gross = parserObject_validateoutbound["gross"]; }catch(err4){ console.log(methName+'err4='+err4); }
    }
    if(gross === null || (typeof gross ==="undefined")){ return ""; }
    return gross.toFixed(2);
  }
  get_dest_ctry_wu_id(){
    let destCountryDescription = localStorage.getItem("TransferOnline1_selCountry_ctry_wu_id");
    return destCountryDescription;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_gotoTransferHome_act(event) {
    let methName = filename+"btn_gotoTransferHome_act ";
    if(api.print_logs){console.log(methName);}

    //+++++++++++++++
    //TransferOnline1
    //+++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));
  }
  //----------------------------------------------------------------------------------------------------
  share_MTCN_act(event) {
    let methName = filename+"share_MTCN_act ";
    if(api.print_logs){console.log(methName);}

    navigator.clipboard.writeText(this.NSInforString("TransferOnline4c_MTCN_share_text")+this.state.mtcn);
    this.Snackbar_textField_handleOpen(this.NSInforString("TransferOnline4c_MTCN_copied"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateName, stateVar) {
    if(api.print_logs){console.log(stateName+" "+stateVar+" "+event.target.value);}
    this.setState({ [stateVar] : event.target.value });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  load_cookies_to_localStorage(){
    let methName = filename+"load_cookies_to_localStorage ";
    if(api.print_logs){console.log(methName);}

    try{
      localStorage.setItem("lang",                          Cookies.get('lang'));
      localStorage.setItem("isLoggedIn",                    Cookies.get('isLoggedIn'));
      localStorage.setItem("accessToken",                   Cookies.get('accessToken'));
      localStorage.setItem("refreshToken",                  Cookies.get('refreshToken'));
      localStorage.setItem("tokenID",                       Cookies.get('tokenID'));
      localStorage.setItem("centralID",                     Cookies.get('centralID'));
      localStorage.setItem("TransferOnline1_PaymentMethod", Cookies.get('TransferOnline1_PaymentMethod'));
      localStorage.setItem("TransferOnline1_TransferMethod",Cookies.get('TransferOnline1_TransferMethod'));
      localStorage.setItem("parserObject_sendoutbound_d2b", JSON.stringify({"centralID":Cookies.get('centralID')}));
      localStorage.setItem("parserObject_sendoutbound",     JSON.stringify({"centralID":Cookies.get('centralID')}));

      localStorage.setItem("TransferOnline1_selCountry_ctry_wu_id",Cookies.get('TransferOnline1_selCountry_ctry_wu_id'));

      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_validateoutbound_d2b = { "gross":parseFloat(Cookies.get('gross')), "normalCharges":parseFloat(Cookies.get('normalCharges')), "principal":parseFloat(Cookies.get('principal')), "expectedActualPayout":parseFloat(Cookies.get('expectedActualPayout')) };
          localStorage.setItem("parserObject_validateoutbound_d2b",JSON.stringify(parserObject_validateoutbound_d2b));
      }
      else{
        let parserObject_validateoutbound       = { "gross":parseFloat(Cookies.get('gross')), "normalCharges":parseFloat(Cookies.get('normalCharges')), "principal":parseFloat(Cookies.get('principal')), "expectedActualPayout":parseFloat(Cookies.get('expectedActualPayout')) };
        localStorage.setItem("parserObject_validateoutbound",JSON.stringify(parserObject_validateoutbound));
      }

      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b_req = { "rcv_fname":Cookies.get('rcv_fname'), "rcv_lname":Cookies.get('rcv_lname'), "rcv_curr":Cookies.get('rcv_curr'), "principal":parseFloat(Cookies.get('principal')), "expectedActualPayout":parseFloat(Cookies.get('expectedActualPayout')) };
        localStorage.setItem("parserObject_sendoutbound_d2b_req",JSON.stringify(parserObject_sendoutbound_d2b_req));
      }
      else{
        let parserObject_sendoutbound_req     = { "rcv_fname":Cookies.get('rcv_fname'), "rcv_lname":Cookies.get('rcv_lname'), "rcv_curr":Cookies.get('rcv_curr'), "principal":parseFloat(Cookies.get('principal')), "expectedActualPayout":parseFloat(Cookies.get('expectedActualPayout')) };
        localStorage.setItem("parserObject_sendoutbound_req",JSON.stringify(parserObject_sendoutbound_req));
      }
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  clear_cookies_not_needed(){
    let methName = filename+"clear_cookies_not_needed ";
    if(api.print_logs){console.log(methName);}

    try{
      //Cookies.remove('lang',                           { path:api.webapp_path});
        Cookies.remove('isLoggedIn',                     { path:api.webapp_path});
        Cookies.remove('accessToken',                    { path:api.webapp_path});
        Cookies.remove('refreshToken',                   { path:api.webapp_path});
        Cookies.remove('tokenID',                        { path:api.webapp_path});
        Cookies.remove('centralID',                      { path:api.webapp_path});
        Cookies.remove('TransferOnline1_PaymentMethod',  { path:api.webapp_path});
        Cookies.remove('TransferOnline1_TransferMethod', { path:api.webapp_path});
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true, "initialLoad":false });
  }
  //----------------------------------------------------------------------------------------------------
}
TransferOnline4c.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(TransferOnline4cStyle)(TransferOnline4c)
);
